/**
 * Widget V2 - PhoneField Component
 *
 * Phone input with a country flag + dialling code selector.
 *
 * The country defaults to the club's own country (saas.country), falling back
 * to UAE — most clients of a club dial from the country the club sits in.
 * Typing a different calling code (e.g. "+44") switches the flag on its own.
 */

import React from "react";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";

import { useWidget } from "/imports/state/WidgetContext";

const FALLBACK_COUNTRY = "AE";

export const isValidPhone = (value) => matchIsValidTel(value || "");

// The field renders a spaced, readable number ("+971 50 123 4567"), but clients
// are de-duplicated on an exact phoneNumber match, so what gets stored has to be
// the compact E.164 form.
export const toE164 = (value) => (value || "").replace(/[\s\-().]/g, "");

function PhoneField({ label = "Phone", value = "", onChange, ...props }) {
  const { saas } = useWidget();
  const defaultCountry = (saas?.country || FALLBACK_COUNTRY).toUpperCase();

  const handleChange = (newValue) => {
    if (onChange) onChange(newValue);
  };

  return (
    <MuiTelInput
      fullWidth
      label={label}
      value={value}
      onChange={handleChange}
      defaultCountry={defaultCountry}
      preferredCountries={[defaultCountry]}
      focusOnSelectCountry
      langOfCountryName="en"
      autoComplete="tel"
      {...props}
    />
  );
}

export default PhoneField;
